<template>
  <RevContainer class="bg-surface-default-hi">
    <div class="flex items-center justify-between">
      <div class="caption-bold py-8">
        <div class="flex h-full items-center gap-24">
          <RevLink
            v-for="{ label, name, url, icon, classNames } in links"
            :key="name"
            class="flex items-center gap-4"
            data-test="footer-link"
            :to="url"
            :tracking="{ name: name, zone: 'header' }"
            :underlined="false"
          >
            <component
              :is="icon"
              v-if="icon"
              :class="[classNames, 'h-16 w-16']"
            />
            <span :class="classNames">
              {{ label }}
            </span>
          </RevLink>
        </div>
      </div>

      <div class="flex items-center gap-24">
        <CountrySwitchMenu />
        <RevLink
          v-if="isRepairEnabled"
          class="flex items-center gap-4"
          :to="`/${locale}/help`"
          :tracking="{ name: i18n(translations.help), zone: 'header' }"
          :underlined="false"
        >
          <IconQuestionMarkInCircle class="h-16 w-16" />
          <span class="caption-bold">
            {{ i18n(translations.help) }}
          </span>
        </RevLink>
      </div>
    </div>
  </RevContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevContainer } from '@ds/components/Container'
import { RevLink } from '@ds/components/Link'
import { IconQuestionMarkInCircle } from '@ds/icons/IconQuestionMarkInCircle'

import { useNavLinks } from '../../../composables/useNavLinks'
import CountrySwitchMenu from '../../CountrySwitch/CountrySwitchMenu.vue'

import translations from './Banner.translations'

const { links } = useNavLinks({ withTradein: false, variant: 'small' })

const experiments = useExperiments()
const { features } = useMarketplace()
const isRepairEnabled = computed(
  () =>
    features.repair.enabled &&
    experiments['experiment.repairCTAInHeader'] === 'withRepairCTAInHeader',
)

const i18n = useI18n()
const locale = useI18nLocale()
</script>
